/* Carrusel de videos por producto: tiles con autoplay muted + modal grande con sonido.
   Custom element vanilla, sin dependencias (coherente con el resto del tema). */
(function () {
  if (customElements.get('product-video-gallery')) return;

  class ProductVideoGallery extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.product-videos__item'));
      this.modal = this.querySelector('[data-video-modal]');
      this.modalVideo = this.querySelector('.product-videos__modal-video');
      if (!this.items.length || !this.modal || !this.modalVideo) return;

      this.index = 0;
      this._activeIndex = 0;
      this.spotlight = this.classList.contains('product-videos--spotlight');
      this._onKeydown = this._onKeydown.bind(this);

      this.items.forEach((item, i) => {
        item.addEventListener('click', () => this.open(i));
      });

      const closeBtn = this.querySelector('[data-modal-close]');
      const prevBtn = this.querySelector('[data-modal-prev]');
      const nextBtn = this.querySelector('[data-modal-next]');
      if (closeBtn) closeBtn.addEventListener('click', () => this.close());
      if (prevBtn) prevBtn.addEventListener('click', () => this.go(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => this.go(1));

      // Cerrar al hacer clic en el backdrop (fuera del stage/controles).
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) this.close();
      });
      // <dialog> nativo: tecla Esc dispara 'cancel'.
      this.modal.addEventListener('cancel', (e) => {
        e.preventDefault();
        this.close();
      });

      // Si solo hay un video, ocultar la navegación.
      if (this.items.length < 2) {
        this.querySelectorAll('.product-videos__modal-nav').forEach((b) => (b.hidden = true));
      }

      this._setupPreviews();
      this._setupArrows();
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      (this.previews || []).forEach((v) => this._detachSource(v));
    }

    // Flechas que hacen scroll del track e indican que el carrusel se desliza.
    // Se ocultan si no hay overflow y se atenúan en los extremos.
    _setupArrows() {
      this.track = this.querySelector('.product-videos__track');
      this.arrows = this.querySelector('[data-arrows]');
      if (!this.track || !this.arrows) return;

      const prevs = Array.from(this.querySelectorAll('[data-scroll-prev]'));
      const nexts = Array.from(this.querySelectorAll('[data-scroll-next]'));

      prevs.forEach((b) => b.addEventListener('click', () => this._goTo(this._activeIndex - 1)));
      nexts.forEach((b) => b.addEventListener('click', () => this._goTo(this._activeIndex + 1)));

      this._buildDots();

      const update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const scrollable = max > 4;
        this.arrows.hidden = !scrollable;
        prevs.forEach((b) => (b.disabled = this.track.scrollLeft <= 2));
        nexts.forEach((b) => (b.disabled = this.track.scrollLeft >= max - 2));
        this._updateActive();
      };

      this.track.addEventListener('scroll', update, { passive: true });
      this._onResize = update;
      window.addEventListener('resize', update);
      update();
    }

    _goTo(i) {
      const item = this.items[Math.max(0, Math.min(this.items.length - 1, i))];
      if (!item || !this.track) return;
      const trackRect = this.track.getBoundingClientRect();
      const r = item.getBoundingClientRect();
      const target = this.spotlight
        ? this.track.scrollLeft + (r.left + r.width / 2) - (trackRect.left + trackRect.width / 2)
        : this.track.scrollLeft + (r.left - trackRect.left);
      this.track.scrollTo({ left: target, behavior: 'smooth' });
    }

    _buildDots() {
      this.dotsWrap = this.querySelector('[data-pagination]');
      this.dots = [];
      if (!this.dotsWrap) return;
      this.dotsWrap.innerHTML = '';
      this.items.forEach((item, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-videos__dot';
        dot.setAttribute('aria-label', 'Ir al video ' + (i + 1));
        dot.addEventListener('click', () => this._goTo(i));
        this.dotsWrap.appendChild(dot);
        this.dots.push(dot);
      });
    }

    _updateActive() {
      if (!this.items.length || !this.track) return;
      const trackRect = this.track.getBoundingClientRect();
      const center = trackRect.left + trackRect.width / 2;
      let active = 0;
      let min = Infinity;
      this.items.forEach((item, i) => {
        const r = item.getBoundingClientRect();
        const c = r.left + r.width / 2;
        const d = Math.abs(c - center);
        if (d < min) {
          min = d;
          active = i;
        }
      });
      this._activeIndex = active;
      this.items.forEach((item, i) => item.classList.toggle('is-active', i === active));
      if (this.dots && this.dots.length) {
        this.dots.forEach((dot, i) => dot.classList.toggle('product-videos__dot--active', i === active));
      }
    }

    // Los tiles deben reproducirse muteados en bucle como preview. El atributo
    // `autoplay` por sí solo no es fiable (varios videos a la vez, preload), así
    // que forzamos play() y lo gobernamos por visibilidad con IntersectionObserver.
    // La fuente se asigna BAJO DEMANDA (HLS 480p) para no bajar el mp4 1080p.
    _setupPreviews() {
      this.previews = this.items
        .map((i) => i.querySelector('video'))
        .filter(Boolean);

      this.previews.forEach((v) => {
        v.muted = true; // requisito para autoplay sin gesto del usuario
        v.setAttribute('muted', '');
        v.playsInline = true;
      });

      // Máximo de tiles reproduciéndose a la vez (protege el rendimiento con
      // muchos reels UGC). El resto quedan como poster hasta que entran/salen.
      this.MAX_PLAYING = 2;
      this._playing = new Set();

      // En conexión lenta / ahorro de datos NO autoreproducimos: dejamos el poster
      // (la foto) visible con el botón play, en vez de un recuadro negro mientras
      // bufferea. Al tocar el tile se abre el modal y se carga el video bajo demanda.
      if (this._isSlowConnection()) return;

      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              if (e.isIntersecting) this._play(e.target);
              else this._stop(e.target);
            });
          },
          { threshold: 0.2, rootMargin: '200px 0px' }
        );
        this.previews.forEach((v) => this._io.observe(v));
      } else {
        this.previews.slice(0, this.MAX_PLAYING).forEach((v) => this._play(v));
      }
    }

    _isSlowConnection() {
      const c =
        navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection;
      if (!c) return false;
      return c.saveData === true || /(^|\b)(slow-2g|2g)$/.test(c.effectiveType || '');
    }

    // Carga hls.js (build light, ~50KB) una sola vez, lazy, solo cuando hace falta.
    _loadHls() {
      if (window.Hls) return Promise.resolve(window.Hls);
      if (!this._hlsLib) {
        this._hlsLib = new Promise((resolve) => {
          const s = document.createElement('script');
          s.src = 'https://cdn.jsdelivr.net/npm/hls.js@1/dist/hls.light.min.js';
          s.async = true;
          s.onload = () => resolve(window.Hls || null);
          s.onerror = () => resolve(null);
          document.head.appendChild(s);
        });
      }
      return this._hlsLib;
    }

    // Asigna la fuente del tile la primera vez que se va a reproducir:
    //   Safari/iOS  -> HLS nativo (elige rendition por tamaño del <video>)
    //   Chrome/FF   -> hls.js capado a la rendition más baja (480p)
    //   sin HLS     -> mp4 (último fallback)
    async _attachSource(v) {
      if (v._srcReady) return;
      const hls = v.dataset.hls;
      const mp4 = v.dataset.mp4;
      if (hls && v.canPlayType('application/vnd.apple.mpegurl')) {
        v.src = hls;
        v._srcReady = true;
      } else if (hls) {
        const Hls = await this._loadHls();
        if (Hls && Hls.isSupported()) {
          const inst = new Hls({
            capLevelToPlayerSize: true, // limita la calidad al tamaño real del tile
            startLevel: 0, // arranca en la rendition más baja (480p)
            maxBufferLength: 6,
            maxMaxBufferLength: 12,
            maxBufferSize: 6 * 1000 * 1000,
            testBandwidth: false,
          });
          inst.loadSource(hls);
          inst.attachMedia(v);
          v._hls = inst;
          v._srcReady = true;
        } else if (mp4) {
          v.src = mp4;
          v._srcReady = true;
        }
      } else if (mp4) {
        v.src = mp4;
        v._srcReady = true;
      }
    }

    // Suelta la fuente y libera buffers al salir del viewport (clave con muchos UGC).
    _detachSource(v) {
      v.pause();
      if (v._hls) {
        v._hls.destroy();
        v._hls = null;
      } else if (v.src) {
        v.removeAttribute('src');
        v.load();
      }
      v._srcReady = false;
    }

    async _play(v) {
      if (this._playing.has(v)) return;
      if (this._playing.size >= this.MAX_PLAYING) return; // deja el poster visible
      this._playing.add(v);
      await this._attachSource(v);
      const p = v.play();
      if (p && typeof p.catch === 'function') {
        // Si el navegador rechaza, reintenta tras cargar metadata.
        p.catch(() => {
          v.addEventListener(
            'loadedmetadata',
            () => {
              const r = v.play();
              if (r && typeof r.catch === 'function') r.catch(() => {});
            },
            { once: true }
          );
        });
      }
    }

    _stop(v) {
      this._playing.delete(v);
      this._detachSource(v);
    }

    open(i) {
      this.index = i;
      this._load(i);
      if (typeof this.modal.showModal === 'function') {
        this.modal.showModal();
      } else {
        this.modal.setAttribute('open', '');
      }
      document.addEventListener('keydown', this._onKeydown);
      // Pausar los previews del track mientras el modal está abierto.
      this._togglePreviews(false);
    }

    close() {
      this.modalVideo.pause();
      this.modalVideo.removeAttribute('src');
      this.modalVideo.load();
      if (typeof this.modal.close === 'function') {
        this.modal.close();
      } else {
        this.modal.removeAttribute('open');
      }
      document.removeEventListener('keydown', this._onKeydown);
      this._togglePreviews(true);
    }

    go(delta) {
      const n = this.items.length;
      this.index = (this.index + delta + n) % n;
      this._load(this.index);
    }

    _load(i) {
      const item = this.items[i];
      if (!item) return;
      const src = item.dataset.srcFull || item.dataset.srcPreview;
      const poster = item.dataset.poster;
      if (poster) this.modalVideo.setAttribute('poster', poster);
      this.modalVideo.src = src;
      this.modalVideo.muted = false;
      this.modalVideo.currentTime = 0;
      const p = this.modalVideo.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});

      // Shoppable: clone the active video's tagged products into the modal strip.
      // Only present in the section variant; product-page usage has no strip.
      const strip = this.modal.querySelector('[data-modal-products]');
      if (strip) {
        const cell = item.closest('[data-video-cell]');
        const tpl = cell && cell.querySelector('[data-item-products]');
        strip.innerHTML = '';
        if (tpl && tpl.content) strip.appendChild(tpl.content.cloneNode(true));
        strip.hidden = !tpl;
      }
    }

    _onKeydown(e) {
      if (e.key === 'ArrowRight') this.go(1);
      else if (e.key === 'ArrowLeft') this.go(-1);
    }

    _togglePreviews(playing) {
      (this.previews || []).forEach((v) => {
        if (playing) this._play(v);
        else this._stop(v);
      });
    }
  }

  customElements.define('product-video-gallery', ProductVideoGallery);
})();
